import { appVersion } from './version'

export const environment = {
  production: true,
  environmentName: 'Release',
  baseUrl: 'https://api.tgmob.com.br/api/',
  googleMapsApiKey: 'AIzaSyA9sanaPLa3B7FntR9EUMdI3ZojdbWoSHg',
  version: appVersion,
}
